export const dataHooks = {
  item: 'item',
};
